.card {
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.heading {
  padding: 16px 18px 10px;
  font-size: 18px;
}

.list {
  margin: 0;
}

.row {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 10px 18px;
  border-top: 1.5px solid var(--ink);
}

.label {
  font-size: 13px;
  color: var(--ink-3);
}

.value {
  margin: 0;
  overflow-wrap: anywhere;
  font-size: 16px;
  font-weight: 600;
}
